export default __webpack_public_path__ + "static/media/logo-blanco-320.9971efc1.png";